<style lang="scss">
.manufacturingTaskTable::before {
  z-index: inherit;
}

.manufacturingTaskTable.el-table--enable-row-hover .el-table__body tr:hover > td {
  background-color: #33333a !important;
}

.manufacturingTaskTable.el-table {
  background-color: transparent;
}

.manufacturingTaskTable.el-table--border:after,
.manufacturingTaskTable.el-table--group:after,
.manufacturingTaskTable.el-table:before {
  background-color: transparent;
}

.manufacturingTaskTable.el-table tr {
  background-color: transparent;
}

.manufacturingTaskTable.el-table td.gutter,
.manufacturingTaskTable.el-table th.gutter {
  background: transparent;
}

// .manufacturingTaskTable .el-table__body-wrapper {
//   background: #1d1d24;
// }

// 滚动条的宽度
.manufacturingTaskTable .el-table__body-wrapper::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

// 滚动条的滑块
.manufacturingTaskTable .el-table__body-wrapper::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

.gridMode::-webkit-scrollbar {
  width: 2px; // 横向滚动条
}

.gridMode::-webkit-scrollbar-thumb {
  background-color: #419fff;
  border-radius: 2px;
}

// .manufacturingTaskTable .el-table__body-wrapper::-webkit-scrollbar-track {
// 	/*滚动条里面轨道*/
// 	border-radius: 2px;
// 	background: #1D1D24;
// }
</style>
<style lang="scss" scoped="scoped">
.gradient-text-one {
  background-image: -webkit-linear-gradient(#85fdff, #ffffff);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}
</style>
<template>
  <div ref="container" style="overflow: auto;height: 100%;position: relative;border: 1px #636363 solid;" :style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#202027' : '#060A6D', 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC', 'box-shadow': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? 'none' : '-5px -5px 30px 0px #4075FF40 inset' }">
    <div ref="titleBar" class="titleBar" style="display: flex;justify-content: space-between;align-items:center ;border-bottom: 1px #636363 solid;padding: 10px;" :style="{ 'border-color': $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#636363' : '#3283FC' }">
      <div style="display: flex;align-items: center;justify-content: space-between;width: 100%;">
        <img style="width: 28px;height: 15px;" src="../../../../assets/img/web/manufacturing/diandian.png" />
        <p class="gradient-text-one" style="font-size: 18px;font-weight: 600;line-height: 22px;">
          {{ $t('renwuzhixingjindu') }}
        </p>
        <img style="width: 28px;height: 15px;" src="../../../../assets/img/web/manufacturing/diandian.png" />
      </div>
    </div>
    <div :style="{ height: contentHeight + 'px' }" style="padding:12px">
      <el-table ref="table" class="manufacturingTaskTable" :data="progresses" style="width: 100%" :max-height="contentHeight" :row-style="{ background: 'transparent', height: rowHeight + 'px' }" :cell-style="{ padding: 0 + 'px', borderColor: 'transparent', color: '#FFFFFF', 'font-size': '14px' }" :header-cell-style="{ background: $attrs.monitorSetting.MONITOR_MANUFACTURING_TEMPLATE == 'black' ? '#33333A' : '#151599', color: '#FFFFFF', padding: '0px', height: '42px', borderColor: 'transparent', 'font-size': '14px' }">
        <template>
          <el-table-column :sortable="false" prop="no" :label="$t('shengchangongdanhao')"></el-table-column>
          <el-table-column :label="$t('gongdanzhuangtai')" width="110">
            <template slot-scope="scope">
              <div style="line-height: 28px;">
                <span :style="{ color: status[scope.row.status].color, 'border-color': status[scope.row.status].color, background: status[scope.row.status].tagBg }" style="border-radius: 2px;font-size: 10px;padding: 3px 8px;box-sizing: border-box;border: 1px solid;">{{ status[scope.row.status].title }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column :label="$t('shengchanjindu')" :width="maxFlowWidth + 'px'">
            <template slot-scope="scope">
              <!-- {{ transform-origin: 0 0;transform: scale(0.6) }} -->
              <div style="width: 100%" :style="{ height: (flowHeights['web_monitor_manufacturing_task_' + scope.$index] != null ? flowHeights['web_monitor_manufacturing_task_' + scope.$index] * 0.68 : 100) + 'px' }">
                <auto_scroll :speed="2" :scale="0.6">
                  <div style=";margin-left: 0px;" :style="{ width: flowWidths['web_monitor_manufacturing_task_' + scope.$index] != null ? flowWidths['web_monitor_manufacturing_task_' + scope.$index] + 'px' : '100%', height: (flowHeights['web_monitor_manufacturing_task_' + scope.$index] != null ? flowHeights['web_monitor_manufacturing_task_' + scope.$index] : 100) + 'px' }" :id="'web_monitor_manufacturing_task_' + scope.$index"></div>
                </auto_scroll>
              </div>
            </template>
          </el-table-column>
          <el-table-column :sortable="false" prop="material.code" :label="$t('chanpinbianma')"></el-table-column>
          <el-table-column :sortable="false" prop="material.name" :label="$t('chanpinmingcheng')"></el-table-column>
          <el-table-column prop="planQuantity" :label="$t('shuliang')"></el-table-column>
          <el-table-column :label="$t('wangongyuceshijian')">
            <template slot-scope="scope">
              {{ scope.row.preFinishTime != null ? dayjs.unix(scope.row.preFinishTime / 1000).format('MM-DD HH:mm') : '' }}
            </template>
          </el-table-column>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script type="text/javascript">
import html2canvas from 'html2canvas';
import print from 'print-js';

export default {
  name: 'web_monitor_manufacturing_task',
  components: {},
  data() {
    return {
      flowHeights: {},
      flowWidths: {},
      x6s: {},
      tableKey: 0,
      status: {
        '1': {
          color: 'rgba(65, 159, 255, 1)',
          title: this.$t('xinjian'),
          tagBg: 'rgba(65, 159, 255, 0.2)',
          cardBg: 'linear-gradient(180deg, #2686E9 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '2': {
          color: 'rgba(65, 159, 255, 1)',
          title: this.$t('fafang'),
          tagBg: 'rgba(65, 159, 255, 0.2)',
          cardBg: 'linear-gradient(180deg, #2686E9 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '3': {
          color: '#39F16D',
          title: this.$t('shengchanzhong'),
          tagBg: 'rgba(57, 241, 109, 0.2)',
          cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '4': {
          color: 'rgba(255, 58, 94, 1)',
          title: this.$t('zanting'),
          tagBg: 'rgba(255, 58, 94, 0.2)',
          cardBg: 'linear-gradient(180deg, #FF3A5E 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '5': {
          color: '#39F16D',
          title: this.$t('shougongxuwangong'),
          tagBg: 'rgba(57, 241, 109, 0.2)',
          cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '6': {
          color: '#39F16D',
          title: this.$t('wangong'),
          tagBg: 'rgba(57, 241, 109, 0.2)',
          cardBg: 'linear-gradient(180deg, #35D258 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '7': {
          color: 'rgba(153, 160, 173, 1)',
          title: this.$t('guanbi'),
          tagBg: 'rgba(153, 160, 173, 0.2)',
          cardBg: 'linear-gradient(180deg, #A5A5A5 0%, rgba(18, 18, 18, 0) 100%)'
        },
        '8': {
          color: 'rgba(255, 200, 58, 1)',
          title: this.$t('yidiaobo'),
          tagBg: 'rgba(255, 200, 58, 0.2)',
          cardBg: 'linear-gradient(180deg, #FA9D2D 0%, rgba(18, 18, 18, 0) 100%)'
        }
      },
      interval: null,
      timmer: null,
      contentHeight: 0,
      rowHeight: 0,
      progresses: [],
      a: false,
      isStopListScroll: false
    };
  },
  created() {
    this.timmer = setInterval(() => {
      this.listProductionProgress();
    }, 600000);
    this.listProductionProgress();
  },
  mounted() {
    this.resize();

    this.utils.event_hub.$on('RESIZE', () => {
      this.resize();
    });
    this.setAutoScroll();
  },
  destroyed() {
    clearInterval(this.timmer);
    clearInterval(this.interval);
  },

  activated() {
    setTimeout(() => {
      this.initPie();
    }, 500);
  },
  watch: {
    '$attrs.orgId'(newValue, oldValue) {
      if (this.utils.isEqual(newValue, oldValue)) {
        return;
      }
      this.listProductionProgress();
    }
  },
  computed: {
    maxFlowWidth() {
      console.log(this.a);
      return 240;
    }
  },
  methods: {
    setAutoScroll() {
      if (this.interval) {
        clearInterval(this.interval);
      }
      const listDiv = this.$refs.table.bodyWrapper;
      this.interval = setInterval(() => {
        if (!this.store.state.is_monitor_full) {
          return;
        }
        if (!this.isStopListScroll) {
          listDiv.scrollTop += 1 / window.devicePixelRatio + 0.05;
          if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
            this.isStopListScroll = true;
            setTimeout(() => {
              if (listDiv.clientHeight + listDiv.scrollTop >= listDiv.scrollHeight) {
                listDiv.scrollTop = 0;
              }
              this.isStopListScroll = false;
            }, 5000);
          }
        }
      }, 100);
    },

    async listProductionProgress() {
      let response = await this.http.get('/web/production/wo/monitor/progress/inproduction', {
        params: {
          orgId: this.$attrs.orgId
        }
      });
      this.progresses = response.data;
      this.$nextTick(() => {
        this.initPie();
      });
    },

    resize() {
      //因为内容高度也是延迟计算的，这里必须设置延迟比外面Index更延迟
      setTimeout(() => {
        if (this.$refs.titleBar == null) {
          return;
        }

        this.contentHeight = this.$refs.container.offsetHeight - this.$refs.titleBar.offsetHeight - 12 - 12;
        this.rowHeight = (this.contentHeight - 42 - 5) / 5;
        this.countFlowHeihgt();
      }, 800);
    },
    initPie() {
      for (var i = 0; i < this.progresses.length; i++) {
        let woProcedureList = this.progresses[i].woProcedureList;
        let nodes = woProcedureList.map(item => {
          return {
            id: item.routeWorkProcedureId + '',
            shape: 'node4',
            width: 83,
            height: 60,
            data: {
              id: 'web_monitor_manufacturing_task_pie_' + i + '_' + item.routeWorkProcedureId,
              color: this.status[this.progresses[i].status].color,
              title: item.procedureDesc,
              percent: item.finishGoodQuantity / item.planQuantity
            }
          };
        });

        let edges = [];
        for (var j = 0; j < woProcedureList.length; j++) {
          let node = woProcedureList[j];
          if (woProcedureList[j].parentIds == '') {
            continue;
          }
          let parentIdArr = woProcedureList[j].parentIds.split(',');
          for (var k = 0; k < parentIdArr.length; k++) {
            edges.push({
              attrs: {
                line: {
                  targetMarker: {
                    tagName: 'circle',
                    r: 2,
                    cx: 2,
                    fill: '#C0C4CC',
                    stroke: '#C0C4CC'
                  },
                  stroke: '#C0C4CC',
                  strokeWidth: 1
                }
              },
              source: parentIdArr[k],
              target: node.routeWorkProcedureId + '',
              router: {
                name: 'manhattan',
                startDirections: ['right'],
                endDirections: ['left']
              }
            });
          }
        }

        this.initFlow('web_monitor_manufacturing_task_' + i, nodes, edges);
        this.countFlowHeihgt();
      }
    },

    initFlow(id, nodes, edges) {
      if (this.x6s[id + '_graph']) {
        this.x6s[id + '_graph'].clearCells();
      }
      if (this.x6s[id + '_x6']) {
        this.x6s[id + '_x6'].clearCells();
      }
      this.x6s[id + '_x6'] = undefined;
      this.x6s[id + '_model'] = undefined;
      this.x6s[id + '_graph'] = undefined;
      if (document.getElementById(id) == null) {
        return;
      }
      document.getElementById(id).innerHTML = '';

      //this.graph
      this.x6s[id + '_x6'] = new this.x6({
        container: document.getElementById(id),
        width: 'auto',
        height: 'auto',
        autoResize: true,
        grid: false,
        interacting: {
          nodeMovable: false
        }
      });

      let model = {
        nodes: nodes,
        edges: edges
      };
      let dagreLayout = new this.x6layout({
        type: 'dagre',
        rankdir: 'LR',
        align: 'UL',
        // rankdir: 'TB',
        // align: 'DR',
        ranksep: 25,
        nodesep: 10,
        controlPoints: true
      });
      //const newModel

      this.x6s[id + '_model'] = dagreLayout.layout(model);
      this.x6s[id + '_graph'] = this.x6s[id + '_x6'].fromJSON(this.x6s[id + '_model']);

      //let a =this.graph.fromJSON(newModel)
      //a = null
      // nodes=null
      // edges=null
      // model = null
      // dagreLayout = null
      // this.models[id] = dagreLayout.layout(model)
      // this.graph.fromJSON(this.models[id])
    },

    countFlowHeihgt() {
      setTimeout(() => {
        for (var i = 0; i < this.progresses.length; i++) {
          36, 78, 120;
          //因为缩放是原点，所有高度越高缩放的时候高度缩小越多，如果单纯硬性增加同样的高度，差距会很大，所以根据竖向层级的数量来不同增加

          let id = 'web_monitor_manufacturing_task_' + i;
          let height = document
            .getElementById(id)
            .getElementsByClassName('x6-graph-svg-viewport')[0]
            .getBoundingClientRect().height;
          let plus = 0;

          if (height <= 36) {
            plus = 50;
          } else if (height <= 78) {
            plus = 80;
          } else if (height <= 120) {
            plus = 120;
          }

          this.flowHeights[id] =
            document
              .getElementById(id)
              .getElementsByClassName('x6-graph-svg-viewport')[0]
              .getBoundingClientRect().height + plus;

          this.flowWidths[id] =
            (document
              .getElementById(id)
              .getElementsByClassName('x6-graph-svg-viewport')[0]
              .getBoundingClientRect().width +
              32) *
            1.67;

          this.a = !this.a;

          //resize两次，等第一次计算结果出来

          //   if (
          //     (this.flowWidths[id] =
          //       document
          //         .getElementById(id)
          //         .getElementsByClassName("x6-graph-svg-viewport")[0]
          //         .getBoundingClientRect().width > 188)
          //   ) {
          //     this.flowWidths[id] =
          //       document
          //         .getElementById(id)
          //         .getElementsByClassName("x6-graph-svg-viewport")[0]
          //         .getBoundingClientRect().width + 260;
          //   } else {
          //     this.flowWidths[id] = 188;
          //   }

          //   if (this.flowWidths[id] > 188) {
          //     this.flowWidths[id] = this.flowWidths[id] + (this.flowWidths[id] / 83) * 20 + 160; //80是左边开头的80
          //   }
        }
      }, 600);
    }
  }
};
</script>
